<template>
  <svg width="272" height="184" viewBox="0 0 400 312" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_546_3906)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M64 32H272.025L320.029 124L272.025 216H64V32ZM275.995 32H279.996L327.999 124L279.996 216H275.995L323.999 124L275.995 32ZM287.996 32H286.996L335 124L286.996 216H287.996L336 124L287.996 32Z" fill="#1B1C1D"/>
    </g>
    <defs>
      <filter id="filter0_d_546_3906" x="0" y="0" width="400" height="312" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="32"/>
        <feGaussianBlur stdDeviation="32"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.18 0 0 0 0 0.2 0 0 0 0 0.22 0 0 0 0.15 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_546_3906"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_546_3906" result="shape"/>
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'AboutUsArrow',
}
</script>
